import request from '@/utils/httpClient'

// customerCompany/
// 批量删除
export function deleteCompanyById(id: number) {
  return request({
    url: `customerCompany/${id}`,
    method: 'delete'
  })
}

// 获取详情
export function getCompanyDetailById(id: number) {
  return request({
    url: `customerCompany/${id}`,
    method: 'get'
  })
}

// 获取列表
export function getCompanyList(params?: object) {
  return request({
    url: 'customerCompany/page',
    method: 'get',
    params
  })
}

// 获取下拉数据
export function getDropdown(params?: object) {
  return request({
    url: 'customerCompany/dropdown',
    method: 'get',
    params
  })
}

// 设置超期提醒
export function noticeSetting(id: number, data?: object) {
  return request({
    url: `customerCompany/${id}/actions/noticeSetting`,
    method: 'put',
    data
  })
}

// 获取审批列表
export function getReviewCompanyList(params?: object) {
  return request({
    url: 'customerCompany/review/page',
    method: 'get',
    params
  })
}

// 获取修改审批信息
export function reviewCustomerCompanyById(id: number) {
  return request({
    url: `customerCompany/review/${id}`,
    method: 'get'
  })
}

// 通过审批
export function reviewApprove(id: number, data?: object) {
  return request({
    url: `customerCompany/${id}/actions/review/approve`,
    method: 'put',
    data
  })
}

// 通过拒绝 TODO: add reject msg
export function reviewReject(id: number, data?: object) {
  return request({
    url: `customerCompany/${id}/actions/review/reject`,
    method: 'put',
    data
  })
}

// 公共客户 name
export function publicPool(params?: object) {
  return request({
    url: 'customerCompany/publicPool',
    method: 'get',
    params
  })
}

// 分配业务员
export function changeSalesMan(id: number | string, data?: object) {
  return request({
    url: `customerCompany/${id}/actions/changeSalesMan`,
    method: 'put',
    data
  })
}

// 设置业绩类型
export function setAchieve(id: number | string, data?: object) {
  return request({
    url: `customerCompany/${id}/actions/achieve`,
    method: 'put',
    data
  })
}
